function handleSwipersOnMobile() {
  const mobileBreakpoint = window.matchMedia('(max-width: 768px)');
  const swiperInstances = new Map();

  function checkScreenSize(event) {
    const containers = document.querySelectorAll('.guarantees-swiper');

    if (event.matches) {
      // Init any not-yet-initialized swipers
      containers.forEach((el) => {
        if (!swiperInstances.has(el)) {
          const swiper = new Swiper(el, {
            slidesPerView: 1,
            loop: false,
            autoplay: { delay: 3000 },
            pagination: {
              el: el.querySelector('.swiper-pagination'),
              clickable: true,
            },
            navigation: {
              nextEl: el.querySelector('.swiper-button-next'),
              prevEl: el.querySelector('.swiper-button-prev'),
            },
          });
          swiperInstances.set(el, swiper);
        }
      });
    } else {
      // Destroy all on desktop
      swiperInstances.forEach((swiper, el) => {
        swiper.destroy(true, true);
        swiperInstances.delete(el);
      });
    }
  }

  // Initial check
  checkScreenSize(mobileBreakpoint);
  // Re-check on viewport changes
  mobileBreakpoint.addListener(checkScreenSize);
}

document.addEventListener('DOMContentLoaded', handleSwipersOnMobile);
